module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_gplay_accent.svg?3dffffa655466254ae542e40db010c45";